export const DefaultLocation = {
  lat: 40.760600,
  lng: -73.965026,
};
